import { utilityService } from '@/services/utilityService.js';

/**
 * WARNING: The order of each item in the lists may be used in conditional statements. Add new items at the end of the
 * array in order to not introduce unwanted behavior throughout the application.
 */

/**
 * Object for configuring the 'Resources & Help' list of links at the landing
 * page.
 * NOTES:
 * (1) single quotes ('') instead of an object is the position where a
 * divider will be added when the list is rendered.
 * (2) make sure external links contain 'http' in order to open them in a new
 * window instead of adding it to the current path.
 */
const helpLinksConfig = [
	'',
	{
		icon: 'add_circle_outline',
		text: 'Create a new study',
		alterText: 'Create a new study (Draft Saved)',
		url: '/create/study'
	},
	'',
	{
		icon: '',
		text: 'What’s New With ASA24?',
		url: '/whatsNew'
	},
	{
		icon: '',
		text: 'Researcher Site Quick User Guide [pdf]',
		// url: '/instructions'
		url: './QuickUserGuide-ASA24-ResearcherSite-FINAL.pdf',
		download: true
	},
	{
		icon: '',
		text: 'Frequently Asked Questions (FAQs)',
		url: 'https://epi.grants.cancer.gov/asa24/resources/faq.html'
	},
	{
		icon: '',
		text: 'Known Issues and Workarounds',
		url: 'https://epi.grants.cancer.gov/asa24/resources/issues.html'
	},
	{
		icon: '',
		text: 'Report a Bug',
		url: '/reportBug'
	},
	{
		icon: '',
		text: 'Join ASA24 Listserv',
		url: 'https://list.nih.gov/cgi-bin/wa.exe?A0=ASA24-L'
	},
	'',
	{
		icon: '',
		text: 'ASA24 Demonstration Site',
		url: utilityService.getDemoUrl()
	},
	'',
	{
		icon: '',
		text: 'Sample Analysis Files and Data Dictionaries',
		url: 'https://epi.grants.cancer.gov/asa24/researcher/sample.html'
	},
	{
		icon: '',
		text: 'Resources Related to the Healthy Eating Index (HEI)',
		url: 'https://epi.grants.cancer.gov/asa24/resources/hei.html'
	},
	{
		icon: '',
		text: 'Dietary Assessment Primer',
		url: 'https://dietassessmentprimer.cancer.gov/'
	}

];

export default helpLinksConfig;
